import types from './types';

const INITIAL_STATE = {
  isFetching: false,

  result: [],
};

const eligibilityImmunizationReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_IMMUNIZATION_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_IMMUNIZATION_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_IMMUNIZATION_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    default:
      return state;
  }
};

export default eligibilityImmunizationReducer;
